import React from 'react';
import Navbar from "../components/Navbar";
import HeroImg from "../components/HeroImg";
import Footer from "../components/Footer";
import AboutContent from '../components/AboutContent';
import Work from "../components/Work";


const Home = () => {
  return (
    <div id="home-top">
      <Navbar />
      <HeroImg />
      <Footer />
      {/* <h1 className="project-heading" style={{ fontSize: '36px' }} >portfolio</h1>
      <Work /> */}

    </div>
  )
}

export default Home